import 'core-js/stable'
import './modals'
import './menu'
import './external-link'
import './hcp-attestation'
